import { Routes } from '@angular/router';
import { AuthGuard } from './shared/helper/auth/guards/auth.guard';
import { NoAuthGuard } from './shared/helper/auth/guards/noAuth.guard';

export const routes: Routes = [
  {
    path: 'sign-in',
    canActivate: [NoAuthGuard],
    loadComponent: () => import('./auth/sign-in/sign-in.component').then((m) => m.SignInComponent),
  },
  {
    path: 'verify',
    loadComponent: () =>
      import('./auth/verify-sso-user/verify-sso-user.component').then(
        (m) => m.VerifySSOUserComponent
      ),
  },
  {
    path: 'verify-password',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./auth/verify-password/verify-password.component').then(
        (m) => m.VerifyPasswordComponent
      ),
  },
  {
    path: 'forgot-password',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./auth/change-password/change-password.component').then(
        (m) => m.ChangePasswordComponent
      ),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'sign-out',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./auth/sign-out/sign-out.component').then((m) => m.SignOutComponent),
  },
  {
    path: '404-not-found',
    pathMatch: 'full',
    loadComponent: () =>
      import('./shared/common/error-404/error-404.component').then((m) => m.Error404Component),
  },
  // fallback: redirect to sign-in for now
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  // { path: '**', redirectTo: 'sign-in' },
  { path: '**', redirectTo: '404-not-found' },
];
